import React from 'react';
import { motion } from 'framer-motion';
import { CONTACT_EMAIL } from '../utils/constants';

const PrivacyPolicy = () => {
  return (
    <div className="pt-32 pb-20 bg-white min-h-screen">
      <div className="max-w-4xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="space-y-12"
        >
          <div className="space-y-4">
            <h1 className="text-5xl md:text-7xl font-black text-brand-black uppercase italic tracking-tighter">
              PRIVACY <span className="text-brand-orange">POLICY.</span>
            </h1>
            <div className="flex items-center gap-4">
              <div className="h-[1px] w-12 bg-brand-orange"></div>
              <p className="text-brand-muted font-black tracking-[0.2em] text-[10px] uppercase">Effective Date: May 24, 2026 // v2.1.0</p>
            </div>
          </div>

          <div className="space-y-12 text-brand-black/90 leading-relaxed font-medium text-sm md:text-base">
            <section className="space-y-6">
              <h2 className="text-2xl font-black text-brand-black flex items-center gap-3">
                <span className="text-brand-orange">01.</span> DATA HARVESTING & SCOPE
              </h2>
              <p>PKRouteX Logistics Solutions ("we," "us," or "our") operates as a technology-first logistics hub. We collect personal identifier information including but not limited to: <strong>Full Names, Contact Numbers, Corporate Email Addresses, and GPS-based Pickup/Drop coordinates.</strong> This data is essential for the initialization of our "Smart Route" protocols and fleet assignment logic.</p>
            </section>

            <section className="space-y-6">
              <h2 className="text-2xl font-black text-brand-black flex items-center gap-3">
                <span className="text-brand-orange">02.</span> OPERATIONAL UTILIZATION
              </h2>
              <p>Your data is processed to ensure cinematic precision in every delivery. We utilize your information for:</p>
              <ul className="list-disc pl-6 space-y-3 marker:text-brand-orange">
                <li>Instant fleet synchronization and WhatsApp-based dispatch updates.</li>
                <li>Dynamic route optimization to reduce carbon footprint and transit time.</li>
                <li>Verification of cargo weight and load type compatibility with assigned Eicher/Dost vehicles.</li>
                <li>Financial auditing and GST-compliant invoicing for industrial contracts.</li>
              </ul>
            </section>

            <section className="space-y-6">
              <h2 className="text-2xl font-black text-brand-black flex items-center gap-3">
                <span className="text-brand-orange">03.</span> THIRD-PARTY ECOSYSTEMS
              </h2>
              <p>To maintain our 99.8% on-time delivery rate, we share relevant transit data with verified vendor partners and cloud infrastructure providers. <strong>PKRouteX does not sell, trade, or leak your industrial data to third-party advertising clusters.</strong> Data sharing is strictly limited to operational necessity.</p>
            </section>

            <section className="space-y-6">
              <h2 className="text-2xl font-black text-brand-black flex items-center gap-3">
                <span className="text-brand-orange">04.</span> INDUSTRIAL-GRADE SECURITY
              </h2>
              <p>We implement the "PK-SECURE" protocol—a multi-layered digital defensive strategy. All web-to-WhatsApp transmissions are encrypted. Internal databases are hosted on secured cloud environments with strict role-based access control (RBAC).</p>
            </section>

            <section className="space-y-6">
              <h2 className="text-2xl font-black text-brand-black flex items-center gap-3">
                <span className="text-brand-orange">05.</span> DIGITAL FOOTPRINT (COOKIES)
              </h2>
              <p>Our site utilizes high-performance cookies to track session telemetry and UI performance. This allows us to ensure the "Cinematic UI" remains fluid across all browser environments.</p>
            </section>

            <section className="space-y-6 border-t border-black/5 pt-12">
              <h2 className="text-2xl font-black text-brand-black">DATA RIGHTS & CONTACT</h2>
              <p>You reserve the right to request a complete audit or deletion of your personal data from our central logistics hub. For such requests, please reach out directly to our Data Protection Officer:</p>
              <div className="bg-slate-50 p-6 rounded-2xl border border-black/5">
                <p className="font-black text-brand-black">DPO // PKRouteX Compliance Dept.</p>
                <p className="text-brand-muted">{CONTACT_EMAIL}</p>
                <p className="text-brand-muted text-xs mt-2 italic px-3 py-1 bg-white inline-block border border-black/5 rounded-full">Available Monday–Friday: 10:00 – 18:00 IST</p>
              </div>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
